import { render } from "./EditOffice.vue?vue&type=template&id=6510febe&scoped=true"
import script from "./EditOffice.vue?vue&type=script&lang=js"
export * from "./EditOffice.vue?vue&type=script&lang=js"

import "./EditOffice.vue?vue&type=style&index=0&id=6510febe&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6510febe"]])

export default __exports__